














































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMSwitch from '@/web/components/common/HMSwitch.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { pick } from 'lodash';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import HMTextInput from '@/web/components/common/HMTextInput.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    HMTextInput,
    HMSwitch,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [DirtyMixin],
  name: 'QuizSettings',
  data() {
    return {
      form: {},
      autoGradableTypes: ['single_choice', 'single_image', 'boolean'],
      isDisableGradable: false,
    };
  },
  computed: {
    ...mapGetters({
      quiz: 'quiz/quiz',
    }),
  },
  methods: {
    async save() {
      try {
        await this.$store.dispatch('quiz/updateQuiz', {
          id: this.quiz.id,
          data: this.form,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_UPDATE_QUIZ'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$refs.form?.reset();
      }
    },
    quizToForm(quiz: QuizResponse) {
      return pick(quiz, [
        'quiz_name',
        'quiz_description',
        'thank_you_email',
        'is_gradable',
        'passing_grade_percent',
        'send_quiz_started_email',
        'send_quiz_ended_email',
        'send_quiz_retake_email',
        'can_students_view_solved_quizzes',
        'can_students_view_correct_answers',
        'allow_retaking_quiz',
      ]);
    },
    isAnswerChecked(element, index, array) {
      return element.is_correct == true;
    },
    checkGradableVisibility() {
      this.quiz.quiz_questions.forEach(question => {
        if (this.autoGradableTypes.indexOf(question.question_type) !== -1) {
          const isChecked = question.answers.some(answer => answer.is_correct);
          if (!isChecked) {
            this.isDisableGradable = true;
          }
        }
      });
      return this.isDisableGradable;
    },
  },
  created() {
    this.form = this.quizToForm(this.quiz);
    this.checkGradableVisibility();
  },
});
